/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      pure lib — the one price statement of the checkout commit points
 *              («€X total for N people · €Y now / €Z at the school»), read off the
 *              /ecommerce_freeprice riepilogo.
 *   users:     controllers/checkout.js `commitPrice` (templates/checkout.hbs,
 *              components/checkout-nuova/summary.hbs + pay.hbs)
 *   tests:     tests/unit/controllers/checkout-commit-undo-test.js
 *   gotchas:   `now` MUST equal the buy button's amount: the deposit when one is due
 *              (preno_acconto_totale > 0), else prezzo_preno. The rest is
 *              totale_struttura without a deposit, the balance (total - deposit) with
 *              one. People are DISTINCT participants (same id on two lines = one).
 */
const num = (v) => {
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : 0;
};

/**
 * @param {object|null} data riepilogo.data
 * @returns {{ total: number, now: number, rest: number, people: number } | null}
 */
export function commitPriceOf(data) {
  if (!data) return null;

  const total = num(data.price_pieno);
  const deposit = num(data.preno_acconto_totale);
  const now = deposit > 0 ? deposit : num(data.prezzo_preno);
  const rest = deposit > 0 ? Math.max(0, total - deposit) : num(data.totale_struttura);

  const people = new Set();
  (data.allProduct || []).forEach((product) => {
    const list = Array.isArray(product?.partecipanti) ? product.partecipanti : [];
    list.forEach((p, i) => {
      people.add(
        p?.id != null
          ? `id:${p.id}`
          : `${p?.nome ?? ''}|${p?.cognome ?? ''}|${p?.data_nascita ?? ''}|${product?.id ?? ''}|${i}`
      );
    });
  });

  return { total, now, rest: rest > 0.004 ? rest : 0, people: people.size };
}
